// AdminLayout.js
import React from 'react';
import { Layout, Menu, Dropdown, Avatar, Button, theme } from 'antd';
import {
  DashboardOutlined,
  UserOutlined,
  SettingOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ShopOutlined,
  LockOutlined,
  PictureOutlined,
  PayCircleOutlined,
  DollarTwoTone,
  DollarCircleOutlined
} from '@ant-design/icons';
import { Link, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

const { Header, Sider, Content } = Layout;

const AdminLayout = () => {
  const { currentAdmin, logout } = useAuth();
  const [collapsed, setCollapsed] = React.useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const userMenu = (
    <Menu>
      <Menu.Item key="profile" icon={<UserOutlined />}>
        Profile
      </Menu.Item>
      <Menu.Item key="settings" icon={<SettingOutlined />}>
        Settings
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined />}
        onClick={logout}
        danger
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  const navItems = [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: <Link to="/admin/dashboard">Dashboard</Link>,
    },
    {
      key: 'packages',
      icon: <PayCircleOutlined />,
      label: <Link to="/admin/manage/packages">Business Packages</Link>,
    },
    {
      key: 'organization',
      icon: <ShopOutlined />,
      label: <Link to="/admin/retailers">Retailers</Link>,
    },
    {
      key: 'business_types',
      icon: <LockOutlined />,
      label: <Link to="/admin/manage/business-types">Business Types</Link>,
    },
    {
      key: 'currencies',
      icon: <DollarCircleOutlined />,
      label: <Link to="/admin/manage/currency">Currencies</Link>,
    },
  ];



  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={220}
      >
        <div className="demo-logo-vertical" style={{
          height: '64px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '18px',
          fontWeight: 'bold'
        }}>
          {collapsed ? 'AD' : 'Admin Dashboard'}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['dashboard']}
          items={navItems}
        />
      </Sider>
      <Layout>
        <Header style={{
          padding: 0,
          background: colorBgContainer,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingRight: '24px'
        }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
          <Dropdown overlay={userMenu} placement="bottomRight">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <Avatar
                src={currentAdmin?.avatar}
                icon={<UserOutlined />}
              />
              <span style={{ fontWeight: '500' }}>{currentAdmin?.name}</span>
            </div>
          </Dropdown>
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            // background: colorBgContainer,
            // borderRadius: '8px'
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;